module.exports = __webpack_public_path__ + "static/img_2090-bcd72aff74753361f28089e44998728e.webp";